import React from 'react';

const WhyChooseUs = () => (
  <section id="why-choose-us" className="why-choose-us section">
    <div className="container section-title">
      <h2>Tentang </h2>
      <div>
        <span>BIMBEL STEMA</span> <span className="description-title">KUPANG</span>
      </div>
    </div>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="features-content">
            <h2>BIMBEL STEMA KUPANG</h2>
            <p className="lead">
              Bimbingan Belajar Stema Kupang didirikan oleh Yayasan St. Yosef Freinadementz pada tahun 2008.
            </p>
            <p>
              Yayasan ini bergerak di bidang pendidikan dan telah mendirikan lembaga Universitas Stella Maris Sumba dan SMK San Jose di Pulau Sumba. Bimbel Stema Kupang bertujuan untuk membantu siswa dalam mempersiapkan diri menghadapi ujian dan melanjutkan pendidikan di berbagai sekolah kedinasan, dengan memberikan materi yang terarah dan bimbingan fisik yang baik.
            </p>
            <div className="features-list">
              <div className="feature-item">
                <div className="feature-icon"><i className="bi bi-award"></i></div>
                <div className="feature-text">
                  <h4>Keahlian Industri</h4>
                  <p>Bimbel Stema Kupang memiliki pengalaman yang luas dalam memberikan bimbingan pendidikan terbaik untuk membantu siswa mencapai tujuan akademis mereka.</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon"><i className="bi bi-graph-up"></i></div>
                <div className="feature-text">
                  <h4>Pendekatan Berdasarkan Data</h4>
                  <p>Kami menggunakan pendekatan berbasis data untuk menyesuaikan metode pengajaran yang sesuai dengan kebutuhan dan perkembangan setiap siswa.</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon"><i className="bi bi-clock-history"></i></div>
                <div className="feature-text">
                  <h4>Penyelesaian Tepat Waktu</h4>
                  <p>Bimbel Stema Kupang berkomitmen untuk memberikan bimbingan yang efisien dan memastikan persiapan ujian dilakukan dengan tepat waktu.</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon"><i className="bi bi-shield-check"></i></div>
                <div className="feature-text">
                  <h4>Hasil yang Terjamin</h4>
                  <p>Dengan pengalaman yang luas dan metode pengajaran yang teruji, kami menjamin hasil yang memuaskan bagi setiap siswa.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="features-image">
            {/* Menghapus pengalaman dan nomor-nomor statistik */}
            <img src="/assets/img/misc/LOGO.png" alt="Logo Bimbel Stema Kupang" className="img-fluid main-image" />
            <div className="experience-badge" style={{ display: 'none' }}>
              {/* Menghapus badge experience */}
              <div className="badge-content">
                <span className="number">15+</span>
                <span className="text">Years of Excellence</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
